module.exports = "/newsfeed/modal-newsfeed-view-47cc78.html";